<template>
  <v-row ref="editForm"
            class="edit-form"
            no-gutters>

    <v-col cols="12"
           sm="6">
      <v-text-field v-model="userForm.postfach"
                    v-validate="'numeric'"
                    :error-messages="errors.collect('postfach')"
                    data-vv-as="Postfach"
                    name="postfach"
                    label="Postfach"
                    hint="Bei Angabe Postfach ist Eingabe von Straße/Hausnr. nicht nötig" />
    </v-col>
    <v-col cols="12"
           sm="6">
           &nbsp;
    </v-col>

    <v-col v-if="!!!userForm.postfach"
           cols="12"
           sm="6">
      <v-text-field v-model="userForm.strasse"
                    v-validate="{ required: true, regex: /^[^!§$%&\/()=?#*+{\[\]}]*$/ }"
                    :error-messages="errors.collect('strasse')"
                    data-vv-as="Straße"
                    class="required"
                    name="strasse"
                    label="Straße" />
    </v-col>

    <v-col v-if="!!!userForm.postfach"
           cols="12"
           sm="6">
      <v-text-field v-model="userForm.hausnummer"
        v-validate="{ required: true, regex: /^[1-9][0-9a-zA-Z-\/,]*$/ }"
        :error-messages="errors.collect('hausnummer')"
        data-vv-as="Hausnummer"
        class="required"
        name="hausnummer"
        label="Hausnummer"
        @change="restrictHausnummer" />
    </v-col>

    <v-col  v-if="!!!userForm.postfach"
           cols="12"
           sm="6">
      <v-text-field v-model="userForm.adresszusatz"
                    label="Adresszusatz"
                    name="adresszusatz" />
    </v-col>

    <v-col cols="12"
           sm="6">
      <v-text-field v-model="userForm.plz"
                    v-validate="{ required: true, regex: /^[0-9]{5} ?$/ }"
                    :error-messages="errors.collect('plz')"
                    data-vv-as="Postleitzahl"
                    class="required"
                    name="plz"
                    label="Postleitzahl"
                    @input="onInputPlz($event, userForm)"/>
    </v-col>

    <v-col cols="12"
           sm="6">
      <v-text-field v-if="cityList.length === 0"
                    v-model="userForm.ort"
                    v-validate="{ required: true, regex: regex.ort }"
                    :error-messages="errors.collect('ort')"
                    data-vv-as="Ort"
                    class="required"
                    name="ort"
                    label="Ort" />
      <v-combobox v-else
                v-model="userForm.ort"
                v-validate="{ required: true, regex: regex.ort }"
                :error-messages="errors.collect('ort')"
                :items="cityList"
                data-vv-as="Ort"
                name="ort"
                class="required"
                label="Ort" />
    </v-col>
  </v-row>
</template>
<script>
import ValidationMixin from "@/components/helper/ValidationMixin";
import plzOrtMixin from "@/components/helper/plzOrtMixin";
import REGEX from "@/validation/regexes";

export default {
  name: "EditAdresse",
  mixins: [ValidationMixin, plzOrtMixin],
  props: {
    userForm: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      regex: REGEX
    };
  },
  methods: {
    restrictHausnummer() { 
      this.hausnummer = this.hausnummer.replace(/[^0-9a-zA-Z-/,]/g, "");//on blur change
    }
  }
};
</script>
